import React from 'react'
import CloseIcon from '@mui/icons-material/Close'
import { Grid, IconButton } from '@mui/material'
import { makeStyles } from '@mui/styles'
import classNames from 'classnames'

import { TableFilter } from '../../../../types'
import Text from '../../../Text'

const useStyles = makeStyles(
  theme => ({
    component: {
      flexWrap: 'nowrap',
    },
    filterChip: {
      '&:not(:last-of-type)': {
        marginRight: theme.spacing(2),
      },
      padding: theme.spacing(0.5, 1),
      width: 'auto',
      backgroundColor: theme.colors.tableBackground,
      border: theme.constants.tableBorder,
      borderRadius: 2,
    },
    icon: {
      marginLeft: theme.spacing(1),
      padding: theme.spacing(0.5),
      color: theme.colors.tabLabel,
    },
  }),
  { name: 'AppliedFilter' },
)

export interface AppliedFilterProps {
  readonly filter: TableFilter
  readonly onClick: () => void
}

const AppliedFilter = ({ filter, onClick }: AppliedFilterProps) => {
  const classes = useStyles()

  return (
    <Grid
      container
      item
      alignItems="center"
      className={classNames(
        classes.filterChip,
        filter.component && classes.component,
      )}
    >
      {filter.component ? (
        filter.component
      ) : (
        <Text variant="lowAccent2">{filter.humanReadable}</Text>
      )}
      <IconButton className={classes.icon} size="large" onClick={onClick}>
        <CloseIcon />
      </IconButton>
    </Grid>
  )
}

export default AppliedFilter
